"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.OptionsPane = void 0;

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/slice"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _AppPanel = require("@uifabric/portal-ux/lib/AppPanel");

var _SwatchPicker = require("@uifabric/portal-ux/lib/SwatchPicker");

var _Link = require("@fluentui/react/lib/Link");

var _Panel = require("@fluentui/react/lib/Panel");

var _Utilities = require("@fluentui/react/lib/Utilities");

var React = _interopRequireWildcard(require("react"));

var styles = require('./Theme.scoped.scss');

var spriteStyles = require('./owa-sprite/styles/theme_sprite.css');
/**
 * Represents the options for settings for the app.
 */


var OptionsPane = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(OptionsPane, _React$Component);

  var _super = (0, _createSuper2.default)(OptionsPane);

  function OptionsPane(nextProps) {
    var _this;

    (0, _classCallCheck2.default)(this, OptionsPane);
    _this = _super.call(this, nextProps);

    _this._renderItem = function (item) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: (0, _Utilities.css)(spriteStyles["theme-icon-".concat(item.key)], styles.themeSwatch),
        title: item.text
      }, item.key);
    };

    _this._toggleViewAll = function () {
      _this.setState((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.state), {}, {
        hideAllThemes: !_this.state.hideAllThemes
      }));
    };

    _this._onChange = function (option) {
      if (option !== undefined) {
        _this.props.changeTheme(option.key);
      }
    };

    _this.state = {
      hideAllThemes: true
    };
    return _this;
  }

  (0, _createClass2.default)(OptionsPane, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.getThemes();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          themes = _this$props.themes;
      var themeOptions = (0, _map.default)(themes).call(themes, function (themeId) {
        return {
          key: themeId,
          text: themeId
        };
      });
      var hideAllThemes = this.state.hideAllThemes;
      var columnCount = 4;
      var themesToShow = hideAllThemes ? (0, _slice.default)(themeOptions).call(themeOptions, 0, columnCount) : themeOptions;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_AppPanel.AppPanel, {
        isOpen: this.props.isOpen,
        type: _Panel.PanelType.smallFixedFar,
        onDismiss: this.props.onDismiss,
        headerText: t('Settings'),
        closeButtonAriaLabel: t('Close'),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          className: styles.themeHeading,
          htmlFor: "themeSelector",
          children: t('Theme')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SwatchPicker.SwatchPicker, {
          id: "themeSelector",
          items: themesToShow,
          columnCount: columnCount,
          onRenderItem: this._renderItem,
          onChange: this._onChange
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
          onClick: this._toggleViewAll,
          children: hideAllThemes ? t('View all themes') : t('View fewer themes')
        })]
      });
    }
  }]);
  return OptionsPane;
}(React.Component);

exports.OptionsPane = OptionsPane;